<template>
    <el-dialog
    title=" "
    :visible.sync="show"
    width="554px"
    top="30px"
    class="contact-dialog"
    :close-on-click-modal="false"
    :show-close="true">
        <el-form ref="form" :rules="rules" :model="form"
        label-width="100px" @submit.native.prevent
        label-position="top">
            <div class="title">Contact Beny<div class="close" @click="close"></div></div>
            <div class="bar windowHeight">
                <el-form-item label=" " prop="type" class="hideLabel">
                    <el-select v-model="form.type">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" " prop="describes" class="hideLabel">
                    <el-input maxlength="5000" type="textarea" v-model="form.describes" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="name" label="Name">
                    <el-input v-model="form.name" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item prop="address" label="Email Address">
                    <el-input v-model="form.address" placeholder=" " maxlength="100"></el-input>
                </el-form-item>
                <el-form-item prop="number" label="Contact number">
                    <el-input v-model="form.number" @input="filter" maxlength="10" placeholder=" "></el-input>
                </el-form-item>
            </div>

            <el-form-item>
                <div class="btn-wrp">
                    <el-button type="primary" @click="onSubmit('form')"
                    class="send-button">Send
                    <i v-if="requesting" class="el-icon-loading"></i>
                    </el-button>
                </div>
            </el-form-item>

        </el-form>
    </el-dialog>

</template>

<script>
import api from '../../api/login'

export default {
    name:'FooterBar',
    props:{
        show:{
            type:Boolean,
            default:()=>{
                return false
            }
        },
        defaultType:{
            type:String,
            default:()=>{
                return ''
            }
        }
    },
    data () {
        return{
            options: [
                {
                    label: 'Beny registration query',
                    value: 'Beny registration query'
                },
                {
                    label: 'Become a Beny partner',
                    value: 'Become a Beny partner'
                },
                {
                    label: 'General or other query',
                    value: 'General or other query'
                }
            ],
            form: {
                type: 'Beny registration query',
                describes: '',
                name: '',
                address: '',
                number: ''
            },
            rules: {
                type: { required: true, message: ' ', trigger: 'change' },
                describes: { required: true, message: ' ', trigger: 'change' },
                name: { required: true, message: ' ', trigger: 'change' },
                address: { required: true, message: ' ', trigger: 'change' },
                number: { required: true, message: ' ', trigger: 'change' }
            },
            requesting: false
        }
    },
    created() {
        if (this.defaultType)
            this.form.type = this.defaultType
        else
            this.form.type = ''
    },
    methods:{
        // 限制输入
        filter () {
            var that = this
            that.form.number = that.form.number.replace(/[^\d]/g,'')
        },
        close () {
            var that = this
            if (that.requesting)
                return
            that.form = {
                type: '',
                describes: '',
                name: '',
                address: '',
                number: ''
            }
            that.$nextTick(() => {
                that.$refs["form"].clearValidate();
                that.$emit('close', false)
            })
        },
        onSubmit (formName) {
            var that = this
            if (that.requesting)
                return
            that.requesting = true
            this.$refs[formName].validate((valid) => {
                that.requesting = false
                let request_params = {
                    "contactNumber": that.form.number,
                    "content": that.form.describes,
                    "emailAddress": that.form.address,
                    "formType": that.form.type,
                    "name": that.form.name
                }
                if (valid) {
                    api.addContact({
                        params: request_params,
                        callback: (res) => {
                            if (!res.data)
                                return
                            if (res.data.code == 200) {
                                that.close()
                            } else{
                                Utils.alert('',res.data.message,'error')
                            }
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.bar{
    max-height:672px;
    overflow-y:auto;
    box-sizing:border-box;
    padding: 24px;
}
.bar::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 17px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 17px;
}
.bar::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    background: #908F8F;
    opacity: 1;
    border-radius: 5px;
}
.bar::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: #4e4c4a;
}
.windowHeight{
    height: 630px;
}
@media (max-height: 900px){
  .windowHeight{
    height: 500px;
  }
}
@media (max-height: 600px){
  .windowHeight{
    height: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/contact.vue